import { createAction, props } from '@ngrx/store';

import {
  AdvertisementDetailDto,
  AdvertisementsListDto,
  AdvertisementSuggestionsDto,
  CreateAdvertisementContactRequestDto,
} from '../api';

export interface SearchAdvertisementsQueryParams {
  query?: string;
  regionId?: number;
  countryCode?: string;
  cityId?: number;
  maxPrice?: number;
  categoryIds?: number[];
  pageSize?: number;
  page?: number;
  suggestionCount?: number;
}

export const listAdvertisementSuggestions = createAction('[Advertisements] List Advertisement suggestions');
export const listAdvertisementSuggestionsSuccess = createAction(
  '[Advertisements] List Advertisement suggestions Success',
  props<{ payload: AdvertisementSuggestionsDto }>(),
);
export const listAdvertisementSuggestionsFailed = createAction(
  '[Advertisements] List Advertisement suggestions Failed',
  props<{ error: string }>(),
);

export const searchAdvertisements = createAction(
  '[Advertisements] List Advertisements',
  props<{ params: SearchAdvertisementsQueryParams }>(),
);
export const searchAdvertisementsSuccess = createAction(
  '[Advertisements] List Advertisements Success',
  props<{ payload: AdvertisementsListDto }>(),
);
export const searchAdvertisementsFailed = createAction(
  '[Advertisements] List Advertisements Failed',
  props<{ error: string }>(),
);

export const getAdvertisement = createAction(
  '[Advertisements] Get Advertisement',
  props<{ advertisementId: number }>(),
);

export const getAdvertisementSuccess = createAction(
  '[Advertisements] Get Advertisement Success',
  props<{ payload: AdvertisementDetailDto }>(),
);

export const getAdvertisementFailed = createAction(
  '[Advertisements] Get Advertisement Failed',
  props<{ error: string }>(),
);

export const sendContactRequest = createAction(
  '[Advertisements] Send contact request',
  props<{ advertisementId: number; payload: CreateAdvertisementContactRequestDto }>(),
);
export const sendContactRequestSuccess = createAction('[Advertisements] Send contact request Success');
export const sendContactRequestFailed = createAction(
  '[Advertisements] Send contact request Failed',
  props<{ error: string }>(),
);
